import { Box } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './footer/Footer';
import Navbar from './navbar/Navbar';
import MobileNavbar from './navbar/MobileNavbar';

const Outletcomponent = ({ isAuthenticated, setIsAuthenticated, isApproved }) => {
  const location = useLocation();
  const isChatPage = location.pathname === '/chat';

  return (
    <div style={{ 
      minHeight: '100dvh',
      height: isChatPage ? '100dvh' : 'auto', 
      display: 'flex', 
      flexDirection: 'column',
      overflow: isChatPage ? 'hidden' : 'visible'
    }}>
      {/* You can add your layout components like header, footer, sidebar, etc. here */}
      <Navbar isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} isApproved={isApproved} />
      <MobileNavbar isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} isApproved={isApproved} />
      <Box sx={{ flex: 1, overflow: isChatPage ? 'hidden' : 'visible' }}>
        <Outlet />
      </Box>
      {!isChatPage && <Footer isAuthenticated={isAuthenticated} isApproved={isApproved} />}
    </div>
  );
};


export default Outletcomponent;
